
import store from '../store'
import * as resultServer from '../api/result'

// 课件复制操作
export async function lessonOper(item,type){
    let res={};
    let lesson=[];
    if(store.state.mulSelect===null && item.unique){
        lesson.push(item);
        let data={
            lesson,
            dir:store.state.menusData.blocksSelected,
            type,
            id:store.state.initConfig.id
        }
        
        res = await resultServer.cacheSet(JSON.stringify(data));
        return res.data==="success"?1:0;
    }else if(store.state.mulSelect!=null){
        let item=[];
        store.state.mulSelect.forEach(v=>{
            item.push(store.state.menusDataIds[v]);
        })

        let data={
            lesson:item,
            dir:store.state.menusData.blocksSelected,
            type:type,
            id:store.state.initConfig.id
        }
        store.state.mulSelect = null
        res = await resultServer.cacheSet(JSON.stringify(data));
        return res.data==="success"?1:0;
    }
    return 0;
}
